import React from 'react';
import PropTypes from 'prop-types';
import { pluginFactoryShape } from './helpers/propTypes';
import LinkedEntitiesCellView from './LinkedEntitiesCellView';
import useGetCellEntities from './helpers/hooks/useGetCellEntities';

const ConnectedLinkedEntitiesCell = ({ container, plugins, sourceEntityId }) => {
  const { entities, isLoading, error } = useGetCellEntities(sourceEntityId);
  return (
    <LinkedEntitiesCellView
      plugins={plugins}
      container={container}
      isLoading={isLoading}
      error={error}
      entities={entities}
    />
  );
};

ConnectedLinkedEntitiesCell.propTypes = {
  /**
   * The target entity type plugins we want to allow linking to.
   */
  plugins: PropTypes.arrayOf(pluginFactoryShape).isRequired,
  /**
   * A container to attach the tooltip to
   */
  container: PropTypes.object,
  /**
   * The entity ID we want to link to.
   */
  sourceEntityId: PropTypes.string.isRequired
};

export default ConnectedLinkedEntitiesCell;
